import React from 'react';
import { Button } from '@mui/material';

const ToggleViewButton = ({ isMonthly, onToggle }) => (
  <Button
    size="small"
    variant="outlined"
    onClick={onToggle}
    sx={{ fontSize: '10px', minWidth: 'auto', px: 1 }}
  >
    {isMonthly ? 'Show Weekly' : 'Show Monthly'}
  </Button>
);

export default ToggleViewButton; 